import { getAxiosClient } from "../../axios-client";
import { OfferClientFinalRefuseRequestBody, OfferClientFinalRefuseResponse } from "./types";
const axiosClient = getAxiosClient();
export const offerClientFinalRefuse = async (body: OfferClientFinalRefuseRequestBody) => {
    return await axiosClient.ax.post<OfferClientFinalRefuseResponse>("Offers/OfferClientFinalRefuse", body);
};
